angular.bootstrap(document.getElementById('ng-bot'), ['bot']);